export const hideDixaMixin = () => ({
    '.dixa-messenger-namespace': { display: 'none !important' },
});
